import React from 'react';

import { SparkleOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';

import { aiActionButtonIconColor, aiActionButtonTextStyles } from './styles';
import { GradientTextProps } from './types';

function GradientText(props: GradientTextProps) {
  const {
    classes,
    component,
    text,
    onClick,
    variant,
    Icon = SparkleOutline,
    showIcon = true,
  } = props;

  return (
    <Stack
      alignItems="center"
      className={cn(classes?.root)}
      component={component}
      // @ts-ignore
      type={component === 'button' ? 'button' : undefined}
      onClick={onClick}>
      {showIcon ? <Icon className={cn(aiActionButtonIconColor, classes?.icon)} /> : null}
      <Typography className={cn(aiActionButtonTextStyles, classes?.text)} variant={variant}>
        {text}
      </Typography>
    </Stack>
  );
}

export default React.memo(GradientText);
